import { APIError } from 'src/api';

/**
 * State of single entity
 */
export interface SingleEntityState<G> {
    isFetching: boolean;
    error?: APIError;
    content?: G;
}

export function singleEntityDefaultState<G>(content?: G): SingleEntityState<G> {
    return {
        isFetching: false,
        error: undefined,
        content,
    };
}
